// extracted by mini-css-extract-plugin
export default {"durationInput":"ecSegmentForm_durationInput__Ox2rg"};